import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDog } from '@fortawesome/free-solid-svg-icons';

const BringYourDogLabel = ({ children = 'Bring Your Dog' }) => (
  <>
    <FontAwesomeIcon icon={faDog} style={{ marginRight: '0.5em' }} />
    {children}
  </>
);

export default BringYourDogLabel;
